import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Papers from './views/Papers.vue';
import Jobs from './views/Jobs.vue';
import PrinterView from './views/PrinterView.vue';
import Settings from './views/Settings.vue';
import Test from './views/Test.vue';
Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/jobs',
      name: 'jobs',
      component: Jobs
    },
    {
      path: '/papers',
      name: 'papers',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Papers.vue')
    },
    {
      path: '/printer',
      name: 'printer',
      component: PrinterView
    },

    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },

    {
      path: '/test',
      name: 'test',
      component: Test
    }
  ]
});
